import script from "./VolunteeringStat.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteeringStat.vue?vue&type=script&setup=true&lang=js"

import "./VolunteeringStat.vue?vue&type=style&index=0&id=4e2b38e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2b38e4"]])

export default __exports__